module.exports = __webpack_public_path__ + "static/media/logo-blue.9ce3b24c.svg";